<template>
  <div>
    <Headline
      :title="title"
      subtitle="Versátil. Disponible. Flexible."
      image="report"
      variant="dark"
    ></Headline>
    <Section image="report-1">
      <Card
        title="Un conjunto de cuadros de mando interactivos"
        size="lg"
      >
        <p>Dashboards de fácil lectura, permiten analizar la tipología de sus viajes de empresa en 5 minutos.</p>
        <h4>Versátil</h4>
        <p>Cuadros de mando, gráficos y listas: analice sus compras desde una perspectiva más macro o entre más en detalle de los servicios</p>
        <h4>Disponible</h4>
        <p>Reciba informes por correo electrónico y configure alertas para compras fuera de los parámetros normales de viaje. Utilice filtros dinámicos o cree sus propias reseñas personales en línea.</p>
        <h4>Flexible</h4>
        <p>Construido sobre la plataforma MicroStrategy, permite el acceso vía Web, Office y Móvil.</p>
      </Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Report',
  path: '/productos/report',
})
const title = useRoute().meta.title
useHead({
  title: `${title} | Geotur`,
})
</script>